
<div class="icon" *ngIf="isSideBar">
    <i-feather [name]="name" class="icon-feather" [ngClass]="iconClass" [ngbTooltip]="iconTooltip"
        [placement]="toolTipPosition"></i-feather>
</div>

<i-feather [name]="name" class="icon-feather" [ngClass]="iconClass" *ngIf="!isSideBar" [ngbTooltip]="iconTooltip"
    [placement]="iconTooltipPosition === '' ? toolTipPosition : iconTooltipPosition" (click)="onDismiss()"></i-feather>
